module.exports = "/img/hero-bg.b26bae94.jpg";